import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import JsonViewer from 'vue-json-viewer/ssr'
import '@/assets/css/common.css'
import 'vue-json-viewer/style.css'
Vue.use(JsonViewer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')